'use strict';

import styles from 'storeLocator/mapStyles';
import Map from 'components/pickupPointMap';
import { applyRendering } from 'util/render';

export default class SlovakParcelServiceMap extends Map {
    init () {
        const self = this;
        const latlng = new google.maps.LatLng(this.initialCoordinates[0], this.initialCoordinates[1]);
        var mapOptions = {
            zoom: 7,
            center: latlng,
            disableDefaultUI: true,
            gestureHandling: 'cooperative',
            styles
        };

        this.countryCode = document.getElementById('country-code').value;
        this.map = new google.maps.Map(this.$target[0], mapOptions);
        this.bounds = new google.maps.LatLngBounds();
        this.infowindow = new google.maps.InfoWindow();

        // Reset zoom after fit bounds
        google.maps.event.addListener(self.map, 'zoom_changed', function () {
            var zoomChangeBoundsListener = google.maps.event.addListener(self.map, 'bounds_changed', function (event) {
                if (this.getZoom() > 1 && this.initialZoom === true) {
                    // Change max/min zoom here
                    this.setZoom(7);
                    this.initialZoom = false;
                }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });

        this.map.initialZoom = true;

        // Handle Geocoding request (look for city, zipcode, ..)
        $('body').on('submit', '#sps-pup-form', (e) => {
            const query = {
                address: $('.sps-input-pup').val(),
                componentRestrictions: {
                    country: 'SK'
                }
            };
            self.geocode(query);
            e.preventDefault();
        });
    }

    fitBounds (shop) {
        // Fit the all the markers in the center of a minimum bounds when any store has been found.
        if (shop && shop.length) {
            this.map.fitBounds(this.bounds);

            // If only one store is found, center and zoom on it
            if (shop.length === 1) {
                this.centerMapOnCoordinates({ lat: shop[0].latitude, lng: shop[0].longitude }, 16);
            }
        }
    }

    updateMarkers (shop) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        var _self = this;
        shop.forEach(element => {
            const storeLocation = new google.maps.LatLng(element.latitude, element.longitude);
            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: element.name,
                icon,
                lat: element.latitude,
                long: element.longitude
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: _self.renderInfoWindowSPS(element)
                });
                this.infowindow.open(this.map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        // Add a marker clusterer to manage the markers.
        if (this.markerCluster) {
            this.markerCluster.clearMarkers(); // Remove the old groups
        }

        this.fitBounds(shop);

        this.initiallyMarkers = this.markers;
    }

    renderInfoWindowSPS (item) {
        var parcelShopData = {
            id: item.id,
            name: item.name,
            address: item.address,
            city: item.city,
            postalCode: item.postalCode,
            latitude: item.latitude,
            longitude: item.longitude
        };

        return applyRendering('parcelShopInfoWindow', parcelShopData);
    }

    geocode (query = false) {
        // eslint-disable-next-line no-undef
        if (!query || query === this.previousQuery) {
            return null;
        }

        // Save previous query to avoid Geocoding the same location multiple times
        this.previousQuery = query;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(query, (res, status) => {
            if (res.length && status === 'OK') {
                var address = res[0].address_components;
                var country = 'SK';

                for (var i = 0; i < address.length; i++) {
                    if (address[i].types.includes('country')) {
                        country = address[i].short_name;
                    }
                }
                const coords = {
                    lat: res[0].geometry.location.lat(),
                    long: res[0].geometry.location.lng(),
                    country: country
                };
                $('body').trigger('spsPickupPointGeocode:update', {
                    success: status === 'OK',
                    data: coords
                });
            } else {
                $('body').trigger('spsPickupPointGeocode:update', {
                    success: status === 'OK',
                    status: status
                });
            }
        });
    }

    updateCoordinates (coordinates) {
        this.centerMapOnCoordinates({ lat: coordinates.lat, lng: coordinates.long }, 10);
    }
}